/**
 * Derive a single, partner-facing job-type label key from a job/offer's
 * active job-type flags. Conditions are evaluated in order — the first match
 * wins — mirroring the rules defined in GID-2544:
 *
 *   remote  && precheck            -> Remote Precheck  / Fernbegehung
 *   !remote && precheck            -> Onsite Precheck   / Vor Ort Begehung
 *   replacement (exchange+install) -> Replacement       / Austausch
 *   migration                      -> Migration         / Migration
 *   installation && !precheck      -> Installation      / Installation
 *   else                           -> ''
 *
 * Returns an i18n key suffix under `job.typeString.*` (empty string when no
 * type applies), so callers translate via `$t('job.typeString.' + key)`.
 *
 * @param {Object} job an offer/job object carrying the `is_*` flags
 * @returns {string} key suffix, or '' when no type matches
 */
export function jobTypeKey(job) {
  if (!job) {
    return '';
  }
  if (job.is_remote && job.is_precheck) {
    return 'remote_precheck';
  }
  if (job.is_precheck) {
    return 'onsite_precheck';
  }
  if (job.is_replacement) {
    return 'replacement';
  }
  if (job.is_migration) {
    return 'migration';
  }
  if (job.is_installation) {
    return 'installation';
  }
  return '';
}
